import React, { cloneElement } from "react";
import Popup from "reactjs-popup";
import { ReactComponent as ArrowIcon } from "../../inlineSvgs/arrow-left.svg";

const ModalWindow = ({ children, btnContent, btnClass, title, bgClass, header = true }) => {
  return (
    <Popup
      className={bgClass ? `modal ${bgClass}` : "modal"}
      trigger={<button className={`modal-button ${btnClass}`}> {btnContent} </button>}
      modal
      lockScroll
    >
      {(close) => (
        <div className="modal">
          <div className="scroll-container">
            {header && (
              <div className="modal-header">
                {title && <p className="title">{title}</p>}
                <button className="close-button" onClick={close}>
                  <ArrowIcon />
                </button>
              </div>
            )}
            {typeof children === "string" ? children : cloneElement(children, { cancel: close })}
          </div>
        </div>
      )}
    </Popup>
  );
};

export default ModalWindow;
